import { MsalInterceptorConfiguration } from "@azure/msal-angular";
import { InteractionType, PublicClientApplication } from "@azure/msal-browser";
import { environment } from "@environments/environment";

const msalInstance = new PublicClientApplication(environment.msalConfig);

const msalGuardConfig: any = {
  interactionType: InteractionType.Redirect, // Tipo di interazione per MSAL Guard
  authRequest: {
    scopes: ['api://' + environment.backendId + '/invoke'],
  },
};

const msalInterceptorConfig: MsalInterceptorConfiguration = {
  interactionType: InteractionType.Redirect, // Tipo di interazione per l'intercettore
  protectedResourceMap: new Map([
    [environment.apiUrl + '', ['api://' + environment.backendId + '/invoke'],],
    ['./assets/i18n/*.json', null],
  ])
}

export const msalConfig = { msalInstance, msalGuardConfig, msalInterceptorConfig };
